// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Bubbles_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.757 17.509a7.5 7.5 0 0 0-5.86-10.704A7.5 7.5 0 1 0 2.243 13.01l-.681 2.316a1.5 1.5 0 0 0 1.863 1.863l2.316-.681a7.5 7.5 0 0 0 2.36.689 7.5 7.5 0 0 0 10.158 3.81l2.316.682a1.5 1.5 0 0 0 1.863-1.862ZM5.812 14.953a.8.8 0 0 0-.211.03L3 15.75l.766-2.602a.75.75 0 0 0-.06-.563 6 6 0 1 1 2.463 2.462.75.75 0 0 0-.356-.094Zm14.418 2.694L21 20.25l-2.602-.766a.75.75 0 0 0-.563.06 6.005 6.005 0 0 1-8.05-2.333 7.493 7.493 0 0 0 6.593-8.8 6 6 0 0 1 3.914 8.67.75.75 0 0 0-.059.566Z',
  viewBox: '0 0 24 24',
  glyph: 'Bubbles_Stroke2_Corner2_Rounded',
})
